export const LICENSE_EXPIRED_BANNER_KEY = 'ls:instance:licenseExpireTime';
export const INCIDENT_BANNER_DISMISSED_KEY = 'ls:incident:dismissed';
